import React from 'react';
import { compose, pick } from 'ramda';
import { branch, renderNothing } from 'recompose';
import { useDeviceSelector } from 'js/store/hooks';
import { PRIZES_VIEW } from '../constants';
import withSanitizedPrizes from './withSanitizedPrizes';
import style from './index.scss';

export const TopPrizes = ({ topPrizes = [], prizesView = PRIZES_VIEW.horizontal }) => {
    const { isMobile, isPortrait } = useDeviceSelector(pick(['isMobile', 'isPortrait']));
    const className = style[isMobile && isPortrait ? PRIZES_VIEW.vertical : prizesView];

    return Boolean(topPrizes.length) && (
        <div className={className}>
            {topPrizes.map(({ hiRank, iconUrl, longDescription: lDesc, className: cls }) => (
                <div key={hiRank} className={style.prize}>
                    <div className={style.prizeInner} style={{ backgroundImage: `url(${iconUrl})` }}>
                        {lDesc && <div className={cls} dangerouslySetInnerHTML={{ __html: lDesc }} />}
                    </div>
                </div>))}
        </div>
    );
};

export const Prizes = ({ className = '', topPrizes, commonPrize, commonPrizeClassName, prizesView }) => (
    <div className={`${style.container} ${className}`}>
        {topPrizes && <TopPrizes topPrizes={topPrizes} prizesView={prizesView} />}
        {commonPrize && <div className={style.commonPrize}>
            <div className={commonPrizeClassName} dangerouslySetInnerHTML={{ __html: commonPrize }} />
        </div>}
    </div>
);

export default compose(
    branch(
        ({ displayPrizes = true }) => !displayPrizes,
        renderNothing
    ),
    withSanitizedPrizes
)(Prizes);
